/**
 * Cold-load full-page loader switches, one per screen that opts in. Flip a flag to false and that
 * screen falls back to its section skeletons on every entry, with no other change needed.
 */
export const FULL_PAGE_LOADER = {
  SMART_MAPPING: true,
  ARTIFACTS_REGISTRY: true,
  AI_TASKS: true,
  TEAR_SHEET: true,
  MULTI_ENTITY: true,
  REGULATORY_WATCH: true,
  POLICIES: true,
  UPPERDECK: true,
  CLIENTS: true,
  BREAK_DOWN: true,
  THIRD_PARTY_OVERVIEW: true,
  THIRD_PARTY_HEAT_MAP: true,
  THIRD_PARTY_DEFAULT_SETTINGS: true,
  THIRD_PARTY_VENDORS: true,
  USERS_SETTINGS: true,
  REMEDIATION: true,
  PILLARS: true,
  REPORTING_GRAPHS: true,
  RISK_REGISTER: true,
  // never leave a screen behind a permanent loader if its data never resolves
  SAFETY_TIMEOUT_MS: 30000,
};
